import React from 'react';

function Terms() {
  return (
    <div className="min-h-screen bg-atc-purple">
      <div className="bg-atc-purple border-b-4 border-atc-yellow">
        <div className="container mx-auto px-4 py-6">
          <div className="flex items-center gap-4">
            <img 
              src="/logo.png" 
              alt="Ask the Class" 
              className="h-16 w-16"
            />
            <h1 className="text-4xl font-bold text-atc-yellow">Ask the Class</h1>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-atc-purple mb-6">Terms and Conditions</h1>
          <p className="text-sm text-gray-500 mb-8">Last Updated: January 12, 2026</p>

          <div className="space-y-6 text-gray-800">
            
            <section>
              <h2 className="text-2xl font-bold text-atc-purple mb-3">1. Acceptance of Terms</h2>
              <p>
                By accessing and using Ask the Class ("the Service"), you accept and agree to be bound by the terms 
                and provision of this agreement. If you do not agree to these Terms and Conditions, please do not 
                use the Service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-atc-purple mb-3">2. Description of Service</h2>
              <p>
                Ask the Class is an anonymous voting platform that allows users to submit questions and receive 
                YES/NO votes from other users. The Service is provided for entertainment and informational purposes only.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-atc-purple mb-3">3. No Professional Advice</h2>
              <p className="mb-3">
                <strong>IMPORTANT:</strong> Ask the Class is NOT a substitute for professional advice of any kind. 
                The votes and results provided through the Service are opinions from anonymous internet users and 
                should not be relied upon for making important life decisions.
              </p>
              <p className="mb-3">
                <strong>The Service does NOT provide:</strong>
              </p>
              <ul className="list-disc ml-6 space-y-2">
                <li>Medical advice, diagnosis, or treatment</li>
                <li>Legal advice or legal opinions</li>
                <li>Financial advice or investment guidance</li>
                <li>Mental health counseling or therapy</li>
                <li>Professional consultation of any kind</li>
              </ul>
              <p className="mt-3">
                You should always consult with qualified professionals (doctors, lawyers, financial advisors, 
                therapists, etc.) before making important decisions affecting your health, legal rights, finances, 
                or wellbeing.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-atc-purple mb-3">4. Disclaimer of Liability</h2>
              <p className="mb-3">
                <strong>USE AT YOUR OWN RISK.</strong> To the maximum extent permitted by law, Ask the Class, 
                its operators, owners, and affiliates SHALL NOT BE LIABLE for any:
              </p>
              <ul className="list-disc ml-6 space-y-2">
                <li>Decisions made based on votes or results from the Service</li>
                <li>Direct, indirect, incidental, consequential, or punitive damages</li>
                <li>Loss of profits, revenue, data, or use</li>
                <li>Personal injury, property damage, or any other harm</li>
                <li>Damages resulting from your reliance on information from the Service</li>
              </ul>
              <p className="mt-3">
                You acknowledge that any reliance on voting results is at your sole risk, and you assume full 
                responsibility for all decisions made based on information obtained through the Service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-atc-purple mb-3">5. Content Moderation Rights</h2>
              <p className="mb-3">
                We reserve the absolute right, at our sole discretion and without prior notice, to:
              </p>
              <ul className="list-disc ml-6 space-y-2">
                <li>Remove, delete, or modify any question or content</li>
                <li>Suspend or terminate user access to the Service</li>
                <li>Refuse service to anyone for any reason</li>
                <li>Monitor, review, and moderate all content</li>
              </ul>
              <p className="mt-3">
                Content may be removed for any reason including, but not limited to: inappropriate content, 
                spam, harassment, illegal activities, violation of these terms, or at our sole discretion 
                without providing a reason.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-atc-purple mb-3">6. User Conduct</h2>
              <p className="mb-3">You agree NOT to use the Service to:</p>
              <ul className="list-disc ml-6 space-y-2">
                <li>Post illegal, harmful, threatening, abusive, or offensive content</li>
                <li>Harass, bully, or threaten other users</li>
                <li>Post spam, advertisements, or solicitations</li>
                <li>Violate any laws or regulations</li>
                <li>Impersonate others or provide false information</li>
                <li>Attempt to hack, disrupt, or damage the Service</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-atc-purple mb-3">7. Privacy and Data</h2>
              <p>
                By using the Service, you acknowledge that questions and votes are collected and may be used 
                for analytics, research, and content creation. While voting is anonymous, submitted questions 
                and voting patterns may be analyzed and shared publicly in aggregate form.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-atc-purple mb-3">8. No Warranties</h2>
              <p>
                THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, either 
                express or implied, including but not limited to warranties of merchantability, fitness for 
                a particular purpose, or non-infringement.
              </p>
              <p className="mt-3">
                We do not warrant that the Service will be uninterrupted, secure, or error-free, or that 
                any defects will be corrected.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-atc-purple mb-3">9. Indemnification</h2>
              <p>
                You agree to indemnify, defend, and hold harmless Ask the Class, its owners, operators, 
                and affiliates from any claims, damages, losses, liabilities, and expenses (including 
                attorney fees) arising from your use of the Service or violation of these Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-atc-purple mb-3">10. Intellectual Property</h2>
              <p>
                All content, features, and functionality of the Service, including but not limited to text, 
                graphics, logos, and software, are owned by Ask the Class and are protected by copyright, 
                trademark, and other intellectual property laws.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-atc-purple mb-3">11. Changes to Terms</h2>
              <p>
                We reserve the right to modify these Terms at any time. Changes will be effective immediately 
                upon posting to the Service. Your continued use of the Service after changes constitutes 
                acceptance of the modified Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-atc-purple mb-3">12. Termination</h2>
              <p>
                We may terminate or suspend access to the Service immediately, without prior notice or 
                liability, for any reason, including breach of these Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-atc-purple mb-3">13. Governing Law</h2>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of Colorado, United States, 
                without regard to its conflict of law provisions.
              </p>
            </section>

            
            <div className="border-t-2 border-gray-300 pt-6 mt-8">
              <p className="text-sm text-gray-600 font-semibold">
                By using Ask the Class, you acknowledge that you have read, understood, and agree to be bound 
                by these Terms and Conditions.
              </p>
            </div>

          </div>

          <div className="mt-8 text-center">
            <a 
              href="/"
              className="inline-block bg-atc-yellow hover:bg-yellow-400 text-atc-purple font-bold py-3 px-8 rounded-lg text-lg transition-colors"
            >
              ← Back to Ask the Class
            </a>
          </div>
        </div>
      </div>

      <footer className="py-8 text-center">
        <p className="text-atc-yellow text-sm">© 2026 Ask the Class. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Terms;